export const SHOW_CANDIDATE_TRANSCRIPT =
  import.meta.env.VITE_SHOW_CANDIDATE_TRANSCRIPT === 'true'
